import { Component, Inject, InjectionToken } from '@angular/core';

export const TOOLTIP_TOKEN = new InjectionToken<string>('tooltip');
export const TOOLTIP_ID_TOKEN = new InjectionToken<string>('id');


@Component({
  selector: 'valg-tooltip',
  templateUrl: './tooltip.component.html',
  host: {'class': 'd-flex'}
})
export class TooltipComponent {

  clicked = false;
  isOpen = false;
  hover = false;

  constructor(
    @Inject(TOOLTIP_TOKEN) public tooltip: string,
    @Inject(TOOLTIP_ID_TOKEN) public id: string){}
  
}